var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"results"}},[(!this.isExtrasModalOpenOnMobile)?_c('sidebar-mobile',{ref:"sidebar",staticClass:"sidebar mobile-only"}):_vm._e(),_c('sidebar-desktop',{staticClass:"sidebar desktop-only"}),_c('CarList',{on:{"modalOpen":_vm.handleModalOpen,"modalClose":_vm.handleModalClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }